/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 付帯商品契約詳細
 */
export interface Sgkb575aResFutaiproductContractdetails {
    /** 
     * 付帯商品契約詳細管理番号：半角数字
     */
    futaiproductContractdetailsMno?: string;
    /** 
     * 名称：全角半角混在
     */
    aname?: string;
    /** 
     * 数量：半角数値(小数点なし)
     */
    quantity?: number;
    /** 
     * 数量単位：半角数字
     */
    quantityUnit?: string;
    /** 
     * 月額利用料：半角数値(小数点あり)
     */
    monthlyUsagefee?: number;
    /** 
     * 月額利用料単位：半角数字
     */
    monthlyUsagefeeUnit?: string;
    /** 
     * 開始年月：日付YYYYMM
     */
    startYm?: string;
}
